import { render, staticRenderFns } from "./BgEditor.vue?vue&type=template&id=1d4e8d54&scoped=true&"
import script from "./BgEditor.vue?vue&type=script&lang=js&"
export * from "./BgEditor.vue?vue&type=script&lang=js&"
import style0 from "./BgEditor.vue?vue&type=style&index=0&id=1d4e8d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e8d54",
  null
  
)

export default component.exports